
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/settings",
      function () {
        return require("private-next-pages/profile/settings.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/settings"])
      });
    }
  